exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.accordion-menu{\n.title{\n    display: flex;\n    justify-content: space-between;\n}\n}\n", ""]);

// exports
